import { Article } from '@ninjacart/nc-nk-core';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { zustandAgriNewsStore } from '../mmkv/mmknAgriNewsPersistence';
import { MMKVStoreKeyMap } from '../mmkv/mmkvStoreKeyMap';

type AppSettings = {
  agriNewsList: Article[];
  setAgriNewsList: (payload: Article[]) => void;
  resetAgriNewsList: () => void;
};

export const useAgriNewsStore = create<AppSettings>()(
  persist(
    (set, get) => ({
      agriNewsList: get()?.agriNewsList ?? [],
      setAgriNewsList: (newArticles: Article[]) =>
        set((state) => ({
          agriNewsList: [...newArticles],
        })),
      resetAgriNewsList: () => set({ agriNewsList: [] }),
    }),
    {
      name: MMKVStoreKeyMap.agriNewsStore,
      storage: createJSONStorage(() => zustandAgriNewsStore),
    }
  )
);
